import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Gallery from './Gallery';
import { getImageDimensions } from '@src/utils/index';
import { formatImage } from '@ifeng-fe/public_method';

const Atlas = ({ content, isLoadGallery }) => {
    const [galleryShow, setGalleryShow] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [galleryCurrent, setGalleryCurrent] = useState(0);
    const [scrollTop, setScrollTop] = useState(0);

    // console.log(content, isLoadGallery, 'content');]
    const handleGalleryOpen = (index) => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
        document.body.style.width = '100%';
        document.body.style.top = `${-scrollTop}px`;
        setGalleryShow(true);
        setGalleryCurrent(0);
        setScrollTop(scrollTop);
    };

    const getAllImageDimensions = async () => {
        const promises = content?.imageInfoList?.map?.((item) => getImageDimensions(item.url));

        try {
            const results = await Promise.all(promises);
            const imageData = [];

            results.forEach((result) => {
                imageData.push({
                    size: 100,
                    width: result.width,
                    url: result.url,
                    height: result.height,
                });
            });
            setImageList(imageData);
        } catch (error) {
            console.error('Error loading image:', error);
        }
    };

    useEffect(() => {
        if (isLoadGallery) {
            getAllImageDimensions();
        }
    }, []);

    const handleGalleryClose = () => {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.top = '0px';

        window.scrollTo(0, scrollTop);
        setGalleryShow(false);
    };
    let galleryText = content?.title + content?.title || '';

    galleryText = galleryText.replace(/<em>/g, '').replace(/<\/em>/g, '');

    return (
        <div className={styles.atlas}>
            <div className={styles.atlasPic}>
                {content?.imageInfoList.slice(0, 3).map((item, index) => {
                    let imageWidth = 690;
                    let imageHeight = 388;

                    if (content.imageInfoList.length === 2) {
                        imageWidth = 340;
                        imageHeight = 340;
                    }

                    if (content.imageInfoList.length >= 3) {
                        imageWidth = 224;
                        imageHeight = 224;
                    }

                    return (
                        <div key={index} className={styles.atlasItem}>
                            <img
                                className={styles.atlasItemPic}
                                src={formatImage(item.url, imageWidth, imageHeight)}
                                onClick={() => {
                                    handleGalleryOpen(index);
                                }}
                            />
                        </div>
                    );
                })}
                {imageList?.length > 3 && <div className={styles.atlasNum}>{imageList.length}</div>}
            </div>
            {imageList.length > 0 && isLoadGallery && (
                <Gallery content={imageList} galleryText={galleryText} galleryShow={galleryShow} galleryCurrent={galleryCurrent} handleGalleryClose={handleGalleryClose} />
            )}
        </div>
    );
};

Atlas.propTypes = {
    content: PropTypes.object,
    isLoadGallery: PropTypes.bool,
};

export default errorBoundary(Atlas);
